/**
 * DemoPage — standalone /demo route for outbound sharing.
 * Single-purpose: big embed + one CTA to register.
 */
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import PromoVideoEmbed from '../components/PromoVideoEmbed';

export default function DemoPage() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100 flex flex-col items-center justify-center px-6 py-12" data-testid="demo-page">
      <Link to="/" className="absolute top-6 left-6 text-sm text-zinc-400 hover:text-white transition-colors" data-testid="demo-back-home">
        ← countbucks.com
      </Link>

      <div className="text-center max-w-2xl mb-10">
        <p className="text-xs uppercase tracking-widest text-violet-400 font-mono mb-3">
          A 60-second tour
        </p>
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight">
          Your AI bookkeeper that <span className="text-violet-400">actually works</span>.
        </h1>
        <p className="mt-4 text-zinc-400 text-sm sm:text-base">
          Drop any document — bill, invoice, tax return, contract — and watch AI Buck read it, file it, and tell you exactly what you owe (or what you saved).
        </p>
      </div>

      <PromoVideoEmbed large />

      <div className="mt-14 flex flex-col items-center gap-3" data-testid="demo-cta">
        <Link
          to="/login?mode=register&plan=starter&cadence=monthly"
          className="inline-flex items-center gap-2 rounded-full bg-white text-zinc-950 px-7 py-3 text-sm font-semibold hover:bg-violet-300 transition-colors"
          data-testid="demo-cta-primary"
        >
          Start your 7-day free trial <ArrowRight className="w-4 h-4" />
        </Link>
        <p className="text-xs text-zinc-500 font-mono">
          Card required · Cancel anytime · Replaces QuickBooks, Bill.com, Dext &amp; more
        </p>
      </div>
    </div>
  );
}
